import React from 'react';
import AsyncLoading from '@components/AsyncLoading/AsyncLoading';

const AdminIndexLazy = React.lazy(
	() => import(/* webpackChunkName : 'AdminIndex' */ './components/AdminIndex')
);

export default (store) => {
	return {
		index: true,
		element: <AsyncLoading component={<AdminIndexLazy />} />,
	};
};
